import { Box, Typography, useTheme } from '@mui/material';
import React, { memo } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import useAuth from '../../hooks/useAuth/useAuth';
import ClickableLink from '../Text/ClickableLink';
import GlassesIcon from '../Icons/GlassesIcon';

function ImpersonateBanner() {
  const theme = useTheme();
  const [t] = useTranslation();
  const { userData } = useAuth();

  return (
    <Box
      sx={{
        position: 'relative',
        padding: '1rem 3rem',
        backgroundColor: theme.palette.monochrome.monoChrome7,
        justifyContent: 'center',
        display: 'flex',
        gap: '0.5rem',
      }}
    >
      <GlassesIcon />
      <Typography sx={{ lineHeight: '1.625rem', color: theme.palette.monochrome.monoChrome1 }}>
        <Trans
          i18nKey="impersonateBanner.message"
          values={{ user: `${userData?.firstName} ${userData?.lastName}`, company: userData?.companyName }}
          components={{ Bold: <strong /> }}
        />
      </Typography>
      <ClickableLink
        sx={{
          position: 'absolute',
          top: '50%',
          right: '1.5rem',
          transform: 'translateY(-50%)',
          color: theme.palette.monochrome.monoChrome1,
          textDecorationColor: theme.palette.monochrome.monoChrome1,
          fontSize: '0.875rem',
          '&:hover': {
            cursor: 'pointer',
            textDecorationColor: theme.palette.monochrome.monoChrome13,
            color: theme.palette.monochrome.monoChrome13,
          },
        }}
        to="/auth"
      >
        {t('impersonateBanner.switchBack')}
      </ClickableLink>
    </Box>
  );
}

export default memo(ImpersonateBanner);
